export const DAIMLER_XENTRY_LINK = 'DAIMLER_XENTRY_LINK';
